import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="header">
        <h1>歡迎來到我的部落格</h1>
        <p>分享我的生活、學習心得和技術文章</p>
        <nav>
          <a href="#about">關於我</a>
          <a href="#articles">文章</a>
          <a href="#contact">聯絡</a>
        </nav>
      </header>

      <section id="about" className="section">
        <h2>關於我</h2>
        <p>我是熱愛技術與學習的人，喜歡分享自己學到的知識，希望能幫助更多人了解程式設計與開發。</p>
      </section>

      <section id="articles" className="section">
        <h2>最新文章</h2>
        <ul>
          <li>React Hooks 初探</li>
          <li>如何開始學習前端開發</li>
          <li>網站性能優化的幾個關鍵技巧</li>
        </ul>
      </section>

      <section id="contact" className="section">
        <h2>聯絡我</h2>
        <p>如果您有任何問題，請透過電子郵件聯絡我：example@email.com</p>
      </section>

      <footer className="footer">
        <p>&copy; 2025 我的部落格 - 版權所有</p>
      </footer>
    </div>
  );
}

export default App;
